import request from '@/utils/api.utils';

export function postContact(id, payload) {
  const url = `/clients/${id}/contacts`;
  return request.post(url, payload);
}
